module.exports = __webpack_public_path__ + "img/santa-claus.398fc56c.svg";